import axios from "axios";

const Axios = axios.create({
  baseURL: `${process.env.REACT_APP_API_URL}api`,
  withCredentials: true, // Cookie httpOnly envoyé automatiquement
});

export default Axios;
